import { MandatoryModuleInfo } from './types';

export const MANDATORY_MODULES: MandatoryModuleInfo[] = [
  {
    id: 'jsa',
    title: 'Job Safety Analysis (JSA)',
    titleEn: 'Job Safety Analysis (JSA)',
    subtitle: 'Analisis Keselamatan Pekerjaan & Identifikasi Bahaya Langkah Kerja',
    subtitleEn: 'Job Safety Analysis & Task Hazard Identification',
    badge: 'JSA',
    estimatedMinutes: 10,
    description: 'Panduan penyusunan dan penerapan JSA untuk memetakan urutan langkah kerja, mengenali potensi bahaya, dan menentukan tindakan pencegahan yang tepat sebelum memulai pekerjaan.',
    slides: [
      {
        id: 1,
        title: 'Pengertian & Tujuan Job Safety Analysis (JSA)',
        titleEn: 'Understanding & Purpose of JSA',
        content: 'JSA adalah metode analisis keselamatan terstruktur yang mengidentifikasi bahaya pada setiap langkah tugas kerja dan menentukan tindakan pencegahan untuk meminimalkan risiko kecelakaan kerja.',
        keyPoints: [
          'Memetakan pekerjaan menjadi langkah-langkah kecil secara berurutan.',
          'Mengenali potensi bahaya mekanis, fisik, kimia, dan lingkungan pada setiap langkah.',
          'Menentukan kontrol pencegahan sesuai Hirarki Pengendalian Risiko (Eliminasi, Subtitusi, Rekayasa Teknik, Administrasi, APD).',
          'Wajib disosialisasikan dan dipahami oleh seluruh anggota tim kerja sebelum aktivitas dimulai.'
        ],
        illustrationType: 'jsa'
      },
      {
        id: 2,
        title: '3 Langkah Utama Pembuatan JSA',
        titleEn: '3 Core Steps in Developing a JSA',
        content: 'Proses pembuatan JSA dilakukan secara sistematis melintasi tiga tahapan inti untuk menjamin keselamatan menyeluruh:',
        keyPoints: [
          '1. Menguraikan Langkah Kerja (Breakdown Task Steps): Menuliskan urutan pekerjaan kronologis dari awal hingga selesai tanpa mengabaikan detail penting.',
          '2. Mengidentifikasi Potensi Bahaya (Identify Potential Hazards): Mengamati apa yang dapat menyebabkan cedera, kerusakan alat, atau bahaya lingkungan di setiap langkah.',
          '3. Menetapkan Tindakan Pengendalian (Develop Control Measures): Menentukan rekomendasi prosedur kerja aman yang spesifik dan terukur.'
        ],
        illustrationType: 'jsa'
      },
      {
        id: 3,
        title: 'Pelaksanaan & Reviu JSA di Lapangan',
        titleEn: 'Field Implementation & Review of JSA',
        content: 'JSA bukan sekadar dokumen di atas kertas, melainkan panduan eksekusi kerja yang hidup di lapangan:',
        keyPoints: [
          'JSA harus direviu kembali saat terjadi perubahan lokasi, cuaca, alat berat, atau personel kerja.',
          'Supervisor / Team Leader wajib melakukan P5M (Pembicaraan 5 Menit) / Safety Talk berpatokan pada JSA.',
          'Pekerja berhak menghentikan pekerjaan (Stop Work Authority) jika kondisi nyata di lapangan tidak sesuai dengan JSA.'
        ],
        illustrationType: 'jsa'
      }
    ],
    questions: [
      {
        id: 'jsa_q1',
        text: 'Apakah definisi utama dari Job Safety Analysis (JSA)?',
        options: [
          'Metode menganalisis biaya dan anggaran proyek',
          'Metode sistematis mengidentifikasi bahaya pada setiap langkah kerja serta menentukan tindakan pencegahannya',
          'Daftar absensi kehadiran pekerja di lapangan',
          'Laporan inventarisasi alat berat perusahaan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'jsa_q2',
        text: 'Manakah urutan 3 langkah utama dalam pembuatan JSA yang benar?',
        options: [
          'Beli APD -> Kerja -> Bikin laporan',
          'Identifikasi Bahaya -> Uraikan Langkah Kerja -> Tetapkan Kontrol',
          'Uraikan Langkah Kerja -> Identifikasi Potensi Bahaya -> Tetapkan Tindakan Pengendalian',
          'Kerja -> Catat Kecelakaan -> Evaluasi'
        ],
        correctOptionIndex: 2,
        points: 10
      },
      {
        id: 'jsa_q3',
        text: 'Kapan JSA wajib direviu kembali oleh tim kerja?',
        options: [
          'Saat terjadi perubahan kondisi cuaca, lokasi kerja, urutan alat, atau personel baru',
          'Setiap 5 tahun sekali saja',
          'Hanya setelah terjadi kecelakaan fatal',
          'Tidak perlu direviu jika dokumen sudah ditandatangani'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'jsa_q4',
        text: 'Dalam Hirarki Pengendalian Risiko, manakah tingkatan kontrol yang paling efektif?',
        options: [
          'Alat Pelindung Diri (APD)',
          'Eliminasi (Menghilangkan sumber bahaya secara total)',
          'Administrasi (Prosedur & Rambu)',
          'Pemakaian sarung tangan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'jsa_q5',
        text: 'Apa tindakan pekerja jika menemukan kondisi lapangan yang tidak sesuai dengan instruksi JSA?',
        options: [
          'Tetap bekerja secepatnya agar selesai',
          'Menggunakan Stop Work Authority (Hentikan Pekerjaan) dan berkoordinasi dengan Supervisor untuk mereviu JSA',
          'Mengabaikan JSA dan bekerja sesuai naluri sendiri',
          'Menyuruh teman kerja lain mengambil risiko'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'jsa_q6',
        text: 'Kapan sosialisasi JSA wajib disampaikan kepada seluruh anggota tim kerja?',
        options: [
          'Sebelum pekerjaan dimulai melalui Safety Talk / P5M (Pembicaraan 5 Menit)',
          'Setelah pekerjaan selesai',
          'Hanya saat ada pemeriksaan dari dinas ketenagakerjaan',
          'Cukup sebulan sekali'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'jsa_q7',
        text: 'Siapakah yang bertanggung jawab mengesahkan dan memverifikasi dokumen JSA sebelum pekerjaan dimulai?',
        options: [
          'Hanya satpam gerbang',
          'Pengawas / Supervisor dan Petugas Keselamatan (EHS/HSE Officer)',
          'Operator truk dari vendor lain',
          'Tamu yang berkunjung'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'jsa_q8',
        text: 'Apa dampak buruk jika langkah kerja dalam JSA diuraikan terlalu umum (misal hanya: "Lakukan perbaikan unit")?',
        options: [
          'Pekerjaan menjadi lebih cepat selesai',
          'Potensi bahaya spesifik pada setiap tahapan kerja tidak dapat diidentifikasi secara menyeluruh',
          'Dokumen menjadi lebih mudah dibaca',
          'Biaya perbaikan menjadi lebih murah'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'jsa_q9',
        text: 'Manakah contoh pengendalian bahaya pada tingkat Rekayasa Teknik (Engineering Control) dalam JSA?',
        options: [
          'Memasang pengaman mesin (machine guard) dan ventilasi hisap debu',
          'Membuat memo edaran keselamatan',
          'Memakai helm dan rompi keselamatan',
          'Memberikan teguran lisan'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'jsa_q10',
        text: 'Mengapa APD (Alat Pelindung Diri) ditempatkan pada tingkatan paling bawah dalam Hirarki Pengendalian Risiko JSA?',
        options: [
          'Karena APD harganya mahal',
          'Karena APD hanya mengurangi dampak keparahan cedera pekerja, bukan menghilangkan sumber bahayanya',
          'Karena APD tidak perlu dipakai jika cuaca panas',
          'Karena APD hanya aksesoris'
        ],
        correctOptionIndex: 1,
        points: 10
      }
    ]
  },
  {
    id: 'defensive_driving',
    title: 'Defensive Driving (Mengemudi Selamat)',
    titleEn: 'Defensive Driving',
    subtitle: 'Prinsip Mengemudi Defensif, P2H & Pencegahan Kecelakaan Lalu Lintas Tambang/Operasional',
    subtitleEn: 'Defensive Driving Principles, Daily Inspection & Road Safety',
    badge: 'DD',
    estimatedMinutes: 10,
    description: 'Modul pengemudian selamat untuk meningkatkan kewaspadaan pengemudi, pelaksanaan pemeriksaan kelayakan unit (P2H), menjaga jarak aman, serta antisipasi bahaya di jalan operasional.',
    slides: [
      {
        id: 1,
        title: 'Konsep & Sikap Pengemudi Defensif',
        titleEn: 'Defensive Driving Mindset & Attitudes',
        content: 'Mengemudi defensif adalah mengemudi untuk menyelamatkan jiwa, waktu, dan uang, terlepas dari kondisi di sekitarnya dan tindakan orang lain.',
        keyPoints: [
          'Alertness (Kewaspadaan): Selalu konsentrasi penuh dan tidak terdistraksi (larangan pakai HP saat mengemudi).',
          'Foresight (Antisipasi): Mampu memprediksi bahaya jauh di depan sebelum bahaya tersebut terjadi.',
          'Knowledge & Skill: Memahami aturan lalu lintas, rambu batas kecepatan, serta karakteristik unit kendaraan.',
          'Judgment (Keputusan Bijak): Mengutamakan keselamatan dibanding kecepatan.'
        ],
        illustrationType: 'driving'
      },
      {
        id: 2,
        title: 'P2H (Pelaksanaan Pemeriksaan Harian) & Blind Spot',
        titleEn: 'Daily Vehicle Inspection (P2H) & Blind Spots',
        content: 'Pemeriksaan pra-operasional menjamin kelayakan mesin dan fitur keselamatan unit sebelum bergerak:',
        keyPoints: [
          'Wajib P2H: Cek Rem, Ban, Lampu Utama/Sein, Klakson, Wiper, Sabuk Pengaman, Kemudi, dan APAR/P3K.',
          'Pahami Area Titik Buta (Blind Spot): Alat berat dan LV memiliki area tidak terlihat yang luas di sekeliling unit.',
          'Selalu lakukan kontak mata atau klakson (1x sebelum starter, 2x maju, 3x mundur) untuk memberi sinyal bahaya.'
        ],
        illustrationType: 'driving'
      },
      {
        id: 3,
        title: 'Jarak Aman Berkendara & Batas Kecepatan',
        titleEn: 'Safe Following Distance & Speed Limits',
        content: 'Aturan jarak aman memberikan waktu reaksi yang cukup dalam situasi darurat:',
        keyPoints: [
          'Aturan 3 Detik (3-Second Rule): Jarak minimum dengan kendaraan di depan pada kondisi jalan kering & normal.',
          'Tambahkan menjadi 4-6 detik pada kondisi jalan basah, berdebu, licin, atau malam hari.',
          'Patuhi batas kecepatan operasional (Maksimal 40 km/jam di area pabrik/site, atau sesuai rambu lokal).',
          'Dilarang mendahului di tikungan, persimpangan, atau area pandangan terhalang.'
        ],
        illustrationType: 'driving'
      }
    ],
    questions: [
      {
        id: 'dd_q1',
        text: 'Apakah yang dimaksud dengan Defensive Driving?',
        options: [
          'Mengemudi dengan kecepatan tinggi agar cepat sampai',
          'Mengemudi untuk menyelamatkan jiwa dan mencegah kecelakaan dengan mengantisipasi potensi bahaya serta kesalahan orang lain',
          'Mengemudi hanya jika jalanan sepi',
          'Mengemudi tanpa menggunakan spion'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q2',
        text: 'Apakah tujuan dari pelaksanaan P2H (Pemeriksaan Pelaksanaan Harian) sebelum mengemudi?',
        options: [
          'Hanya untuk mengisi kelengkapan formulir admin',
          'Memastikan unit kendaraan dalam kondisi layak jalan dan fitur keselamatan berfungsi normal',
          'Mencuci mobil agar bersih',
          'Menghabiskan waktu sebelum jam kerja'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q3',
        text: 'Berapakah jarak waktu aman mengikuti kendaraan di depan dalam kondisi jalan normal (Aturan Jarak Aman)?',
        options: [
          '1 Detik',
          '3 Detik',
          '10 Detik',
          '0.5 Detik'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q4',
        text: 'Apakah kode isyarat klakson standar sebelum menggerakkan unit kendaraan mundur?',
        options: [
          '1 kali bunyi klakson',
          '2 kali bunyi klakson',
          '3 kali bunyi klakson',
          'Tidak perlu membunyikan klakson'
        ],
        correctOptionIndex: 2,
        points: 10
      },
      {
        id: 'dd_q5',
        text: 'Bagaimanakah sikap mengemudi yang aman mengenai penggunaan HP saat berkendara?',
        options: [
          'Boleh mengetik pesan jika di jalan lurus',
          'Dilarang keras menggunakan HP/telpon saat mengemudi karena merusak konsentrasi dan meningkatkan risiko kecelakaan',
          'Boleh pakai HP asal menggunakan handsfree sambil mengebut',
          'Boleh membalas obrolan jika kendaraan jalan pelan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q6',
        text: 'Berapakah jarak aman minimum yang direkomendasikan saat kondisi jalan basah, licin, atau berkabut tebal?',
        options: [
          '1-2 Detik',
          '4-6 Detik',
          'Tetap sama seperti jalan kering',
          'Cukup setengah detik'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q7',
        text: 'Apakah yang dimaksud dengan Blind Spot pada kendaraan atau alat berat?',
        options: [
          'Lampu depan yang rusak',
          'Area di sekitar kendaraan yang tidak dapat dilihat langsung oleh pengemudi melalui kaca depan maupun spion',
          'Kaca spion yang kotor',
          'Ban serep di belakang kendaraan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q8',
        text: 'Siapakah yang wajib mengenakan sabuk pengaman (Seat Belt) saat kendaraan operasional bergerak?',
        options: [
          'Hanya pengemudi',
          'Pengemudi dan seluruh penumpang tanpa kecuali',
          'Hanya penumpang di kursi depan',
          'Tidak wajib jika jarak tempuh dekat'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'dd_q9',
        text: 'Berapakah kode klakson standar sebelum menyalakan mesin (starter) alat berat di area tambang/workshop?',
        options: [
          '1 kali bunyi klakson (tunggu sesaat sebelum starter)',
          '3 kali bunyi klakson panjang',
          '5 kali bunyi klakson berturut-turut',
          'Dilarang membunyikan klakson'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'dd_q10',
        text: 'Apa yang wajib dilakukan jika pengemudi mulai merasakan kantuk berat (fatigue / microsleep) saat berkendara?',
        options: [
          'Menyetel musik dengan volume maksimal dan tetap tancap gas',
          'Membuka jendela lebar-lebar sambil menelepon teman',
          'Segera menepikan kendaraan di area aman (rest point) dan beristirahat / tidur sejenak',
          'Minum minuman berenergi dan memacu kecepatan kendaraan'
        ],
        correctOptionIndex: 2,
        points: 10
      }
    ]
  },
  {
    id: 'loto',
    title: 'Lock Out & Tag Out (LOTO)',
    titleEn: 'Lock Out & Tag Out (LOTO)',
    subtitle: 'Isolasi Energi Berbahaya, Gembok & Tag Keselamatan Perbaikan Mesin',
    subtitleEn: 'Hazardous Energy Control, Lock & Danger Tag Safety',
    badge: 'LOTO',
    estimatedMinutes: 10,
    description: 'Prosedur keselamatan isolasi sumber energi (listrik, mekanis, hidrolik, pneumatik) untuk mencegah pengaktifan mesin tanpa sengaja selama pekerjaan servis atau perbaikan.',
    slides: [
      {
        id: 1,
        title: 'Prinsip Dasar & Jenis Energi Berbahaya LOTO',
        titleEn: 'Basic Principles & Hazardous Energy Types',
        content: 'LOTO mengunci dan menandai titik isolasi energi untuk menjamin tidak ada energi tersimpan yang lepas saat teknisi bekerja di dalam mesin.',
        keyPoints: [
          'Jenis Energi: Listrik, Mekanis, Hidrolik, Pneumatik, Termal, Kimia, dan Gravitasi.',
          'Lock Out: Pemasangan gembok khusus fisik pada titik pemutus energi (Breaker/Valve).',
          'Tag Out: Label peringatan bahaya yang mencantumkan nama pekerja, tanggal, dan alasan penguncian.',
          'Prinsip 1 Pekerja = 1 Gembok = 1 Kunci (Kunci LOTO dipegang sendiri oleh pekerja terotorisasi).'
        ],
        illustrationType: 'loto'
      },
      {
        id: 2,
        title: '6 Langkah Standar Prosedur LOTO',
        titleEn: '6 Standard Steps of LOTO Procedure',
        content: 'Pelaksanaan LOTO wajib mengikuti 6 langkah berurutan secara disiplin tanpa ada yang terlewati:',
        keyPoints: [
          '1. Persiapan Shutdown: Kenali jenis sumber energi dan alat isolasi.',
          '2. Mematikan Mesin (Shutdown): Matikan unit menggunakan kontrol operasional resmi.',
          '3. Isolasi Sumber Energi: Putuskan saklar utama / tutup valve isolasi.',
          '4. Pemasangan LOTO: Pasang Gembok LOTO & Tag Out pribadi pada titik isolasi.',
          '5. Pelepasan Energi Tersimpan (Dissipate Stored Energy): Rilis tekanan hidrolik, buang sisa angin pneumatik, grounding kapasitor.',
          '6. Verifikasi Nol Energi (Zero Energy Verification): Tes coba nyalakan mesin (Try Out) untuk memastikan energi benar-benar Nol (0).'
        ],
        illustrationType: 'loto'
      },
      {
        id: 3,
        title: 'Pelepasan LOTO & Larangan Merusak Gembok',
        titleEn: 'LOTO Removal & Unauthorized Padlock Removal Rules',
        content: 'Aturan ketat saat penyelesaian pekerjaan perbaikan mesin:',
        keyPoints: [
          'Hanya pemilik gembok yang berhak melepas gembok LOTO milik dirinya sendiri setelah pekerjaan selesai.',
          'Pastikan seluruh tim telah keluar dari area bahaya mesin sebelum gembok dilepas.',
          'Pelepasan Gembok Darurat hanya boleh dilakukan oleh Supervisor Terotorisasi dengan Berita Acara resmi usai verifikasi keamanan.'
        ],
        illustrationType: 'loto'
      }
    ],
    questions: [
      {
        id: 'loto_q1',
        text: 'Apakah fungsi utama dari penerapan prosedur Lock Out & Tag Out (LOTO)?',
        options: [
          'Agar mesin tidak dicuri orang',
          'Mengisolasi sumber energi berbahaya dan mencegah pengaktifan mesin secara tidak sengaja saat perbaikan',
          'Mempercepat proses pembersihan ruangan',
          'Menandai mesin yang sudah dijual'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'loto_q2',
        text: 'Siapakah yang berhak memegang anak kunci gembok LOTO pribadi yang terpasang?',
        options: [
          'Hanya pekerja terotorisasi yang memasang gembok tersebut',
          'Setiap orang yang lewat',
          'Satpam di gerbang utama',
          'Ditinggal terpasang pada gemboknya'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'loto_q3',
        text: 'Apakah langkah ke-6 (terakhir) yang sangat krusial dalam prosedur LOTO sebelum bekerja?',
        options: [
          'Langsung masuk ke dalam mesin tanpa tes',
          'Pelepasan Energi Tersimpan & Verifikasi Nol Energi (Zero Energy Test / Try Out)',
          'Membuang tag keselamatan ke tempat sampah',
          'Menghubungkan kembali listrik'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'loto_q4',
        text: 'Manakah di bawah ini yang TERMASUK contoh sumber energi tersimpan yang wajib dirilis saat LOTO?',
        options: [
          'Sinar matahari',
          'Tekanan fluida hidrolik, angin kompresor pneumatik, dan pegas tertekan',
          'Suara bising',
          'Lampu penerangan jalan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'loto_q5',
        text: 'Bolehkah seorang pekerja melepas gembok LOTO milik rekan kerjanya tanpa izin resmi?',
        options: [
          'Boleh jika sedang terburu-buru pulang',
          'Sangat Dilarang! Pelepasan gembok orang lain adalah pelanggaran berat dan hanya dapat dilakukan lewat prosedur khusus supervisor terotorisasi',
          'Boleh asal gembok dirusak pakai palu',
          'Boleh saja tanpa perlu koordinasi'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'loto_q6',
        text: 'Informasi apa sajakah yang WAJIB tertulis pada kartu Tag Out bahaya?',
        options: [
          'Nama pemasang, departemen/perusahaan, tanggal/jam pemasangan, alasan isolasi, dan nomor kontak',
          'Daftar menu makan siang',
          'Nomor plat kendaraan pribadi',
          'Jadwal cuti tahunan'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'loto_q7',
        text: 'Apakah alat yang wajib digunakan jika satu titik isolasi dikunci oleh lebih dari satu orang pekerja (Group LOTO)?',
        options: [
          'Kabel kawat jemuran',
          'Hasps (Pengait Multi-Gembok LOTO)',
          'Pita perekat lakban',
          'Tali rafia'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'loto_q8',
        text: 'Mengapa mematikan mesin HANYA melalui tombol Emergency Stop tidak memenuhi standar isolasi LOTO?',
        options: [
          'Karena tombol emergency stop bisa macet',
          'Karena tombol hanya memutus rangkaian kontrol sementara, bukan memutus sumber energi utama dari pemutus sirkuit/valve',
          'Karena warna tombolnya merah',
          'Karena tombol emergency stop harganya mahal'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'loto_q9',
        text: 'Apakah yang wajib dipastikan sebelum gembok LOTO dilepas setelah pekerjaan servis selesai?',
        options: [
          'Memastikan seluruh personil berada di luar zona bahaya mesin dan pelindung pengaman mesin terpasang kembali',
          'Langsung menyalakan saklar tanpa melihat sekitar',
          'Menyuruh orang lain menjauh dengan berteriak',
          'Meninggalkan peralatan bengkel di dalam mesin'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'loto_q10',
        text: 'Kapan prosedur pelepasan gembok darurat (Emergency Lock Removal) boleh diterapkan?',
        options: [
          'Kapan saja teknisi malas mencari anak kuncinya',
          'Hanya setelah diverifikasi pemilik gembok tidak berada di lokasi, area dipastikan aman, dan disetujui Supervisor Resmi dengan Berita Acara',
          'Saat istirahat makan siang',
          'Jika gembok LOTO kotor terkena oli'
        ],
        correctOptionIndex: 1,
        points: 10
      }
    ]
  },
  {
    id: 'slinging_lifting',
    title: 'Slinging & Lifting (Pengangkatan Beban)',
    titleEn: 'Slinging & Lifting Operations',
    subtitle: 'Keselamatan Pengangkatan Crane, Rigging, Beban Tergantung & SWL Alat Bantu Angkat',
    subtitleEn: 'Crane Rigging Safety, Suspended Loads & Lifting SWL',
    badge: 'SL',
    estimatedMinutes: 10,
    description: 'Keselamatan operasi pengangkatan menggunakan crane/hoist, inspeksi kelayakan alat bantu angkat (sling/shackle), kalkulasi SWL, serta pencegahan bahaya Line of Fire.',
    slides: [
      {
        id: 1,
        title: 'Kompetensi Personel & Elemen Pengangkatan',
        titleEn: 'Lifting Personnel Roles & Key Elements',
        content: 'Pengangkatan mekanis harus dipandu oleh personil terlatih dengan pembagian peran yang jelas:',
        keyPoints: [
          'Crane Operator: Mengoperasikan alat angkat yang memiliki sertifikat SIO aktif.',
          'Rigger (Juru Ikat): Memilih, menginspeksi, dan mengikat sling pada beban secara seimbang.',
          'Signalman (Juru Sinyal): Memberikan aba-aba sinyal standar tangan/radio kepada operator.',
          'Setiap operasi wajib memiliki Rencana Pengangkatan (Lifting Plan) untuk beban berat / kritikal.'
        ],
        illustrationType: 'lifting'
      },
      {
        id: 2,
        title: 'Inspeksi Alat Bantu Angkat (Rigging Hardware) & SWL',
        titleEn: 'Rigging Hardware Inspection & Safe Working Load (SWL)',
        content: 'Seluruh alat bantu angkat wajib diperiksa secara visual sebelum digunakan (Pre-Use Inspection):',
        keyPoints: [
          'Periksa SWL (Safe Working Load): Dilarang mengangkat beban melebihi kapasitas SWL tertera.',
          'Akir/Afkir Alat Bantu jika ditemukan: Webbing sling robek/terbakar, Wire rope rantas/kink, Hook tanpa safety latch, Shackle aus >10%.',
          'Sudut Pengangkatan (Sling Angle Factor): Semakin kecil sudut sling (<60°), tegangan beban pada kaki sling semakin besar!'
        ],
        illustrationType: 'lifting'
      },
      {
        id: 3,
        title: 'Zona Bahaya (Line of Fire) & Aturan Pengangkatan',
        titleEn: 'Line of Fire Hazard Zone & Lifting Rules',
        content: 'Area bawah dan sekeliling beban tergantung adalah zona bahaya fatal yang harus disterilkan:',
        keyPoints: [
          'Dilarang keras berdiri, melintas, atau bekerja di bawah beban yang sedang tergantung (Suspended Load).',
          'Gunakan Tali Pandu (Tag Line) untuk mengendalikan ayunan beban dari jarak aman, jangan menahan beban langsung dengan tangan.',
          'Pasang Barikade / Barricade Tape & Rambu Peringatan "Dilarang Masuk - Ada Pengangkatan" di sekitar radius ayun crane.'
        ],
        illustrationType: 'lifting'
      }
    ],
    questions: [
      {
        id: 'sl_q1',
        text: 'Apakah kepanjangan dari istilah SWL pada alat bantu angkat?',
        options: [
          'Safety Weight Level',
          'Safe Working Load (Beban Kerja Aman)',
          'Single Wire Line',
          'System Working License'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q2',
        text: 'Siapakah personil yang bertugas melakukan pengikatan beban dan menginspeksi sling sebelum diangkat?',
        options: [
          'Driver truk sembarangan',
          'Rigger (Juru Ikat) terlatih dan tersertifikasi',
          'Petugas kebersihan',
          'Admin kantor'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q3',
        text: 'Manakah tindakan keselamatan yang WAJIB dipatuhi saat beban sedang diangkat oleh crane?',
        options: [
          'Berdiri persis di bawah beban agar bisa memegang material',
          'Dilarang keras melintas atau berada di bawah beban tergantung (Suspended Load)',
          'Duduk santai di atas beban saat diangkat',
          'Melepas helm keselamatan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q4',
        text: 'Apakah fungsi utama dari penggunaan Tali Pandu (Tag Line) saat operasi pengangkatan?',
        options: [
          'Untuk mengikat sepatu rigger',
          'Mengendalikan putaran/ayunan beban dari jarak aman tanpa menyentuh beban langsung dengan tangan',
          'Menambah berat beban yang diangkat',
          'Sebagai pengganti kait crane (hook)'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q5',
        text: 'Kapan webbing sling atau wire rope HARUS afkir / dihentikan penggunaannya?',
        options: [
          'Jika kain sling robek, serat terputus, kawat rantas, atau tidak memiliki label SWL',
          'Setiap kali sling dalam keadaan bersih',
          'Hanya setelah digunakan selama 20 tahun',
          'Jika sling berwarna hijau'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'sl_q6',
        text: 'Bagaimanakah pengaruh sudut kaki sling (Sling Angle) terhadap beban tegangan yang dialami sling?',
        options: [
          'Sudut pengangkatan tidak mempengaruhi tegangan sling sama sekali',
          'Semakin kecil sudut sling terhadap bidang horizontal (<60°), tegangan beban pada masing-masing kaki sling akan meningkat drastis',
          'Semakin kecil sudut, beban pada sling menjadi nol',
          'Tegangan sling hanya ditentukan oleh warna sling'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q7',
        text: 'Apakah fungsi dari Safety Latch pada pengait (hook) crane?',
        options: [
          'Mencegah mata sling atau shackle terlepas keluar dari kait crane saat proses pengangkatan',
          'Sebagai hiasan agar hook terlihat menarik',
          'Untuk memotong tali sling yang terlalu panjang',
          'Sebagai pemberat tambahan pada hook'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'sl_q8',
        text: 'Siapakah yang berhak memberikan aba-aba Berhenti Darurat (Emergency Stop) kepada operator crane saat melihat bahaya?',
        options: [
          'Hanya Direktur Perusahaan',
          'Siapa saja di lokasi kerja yang melihat adanya bahaya langsung terhadap keselamatan',
          'Hanya polisi lalu lintas',
          'Hanya pemilik barang yang diangkat'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q9',
        text: 'Kapan Rencana Pengangkatan (Lifting Plan) wajib dibuat dan disahkan sebelum operasi lifting?',
        options: [
          'Hanya saat mengangkat kardus kosong',
          'Pada pengangkatan kritis, beban berat (> beban tertentu), pengangkatan tandem (2 crane), atau di dekat instalasi bertegangan tinggi',
          'Tidak pernah diperlukan di proyek mana pun',
          'Hanya setelah beban terjatuh'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sl_q10',
        text: 'Apakah yang harus dilakukan sebelum mengangkat beban untuk memastikan keseimbangan titik berat (Center of Gravity)?',
        options: [
          'Langsung mengangkat beban ke ketinggian maksimum dengan kecepatan tinggi',
          'Lakukan uji angkat awal (trial lift) setinggi 10-20 cm dari tanah untuk memeriksa keseimbangan ikatan dan fungsi rem crane',
          'Mendorong beban sambil berayun',
          'Menyuruh orang duduk di sisi beban yang lebih ringan'
        ],
        correctOptionIndex: 1,
        points: 10
      }
    ]
  },
  {
    id: 'safety_golden_rules',
    title: 'Safety Golden Rules (Aturan Emas Keselamatan)',
    titleEn: 'Safety Golden Rules',
    subtitle: '10 Aturan Emas Keselamatan Kerja Wajib, Hak Stop Work & Zero Tolerance Policy',
    subtitleEn: '10 Mandatory Safety Golden Rules, Stop Work Authority & Zero Tolerance',
    badge: 'SGR',
    estimatedMinutes: 10,
    description: 'Sepuluh aturan keselamatan mutlak yang mengatur kepatuhan bekerja di ketinggian, ruang terbatas, isolasi energi, perizinan kerja, dan budaya Stop Work Authority.',
    slides: [
      {
        id: 1,
        title: 'Konsep Safety Golden Rules & Zero Tolerance',
        titleEn: 'Safety Golden Rules Concept & Zero Tolerance',
        content: 'Safety Golden Rules adalah prinsip dasar keselamatan kerja non-kompromi untuk melindungi seluruh karyawan dan mitra kerja dari risiko cedera fatal (fatality).',
        keyPoints: [
          'Non-Kompromi: Kepatuhan terhadap aturan emas bersifat mutlak tanpa pengecualian.',
          'Zero Tolerance Policy: Pelanggaran disengaja terhadap aturan emas dapat dikenakan sanksi disiplin berat hingga pemutusan hubungan kerja.',
          'Tujuan Utama: Mencapai sasaran Zero Accident & Zero Fatality di seluruh area operasional.'
        ],
        illustrationType: 'rules'
      },
      {
        id: 2,
        title: 'Hak Menghentikan Pekerjaan (Stop Work Authority)',
        titleEn: 'Stop Work Authority (SWA) Rights',
        content: 'Setiap individu di area kerja (karyawan, subkontraktor, maupun tamu) memiliki wewenang penuh untuk menghentikan pekerjaan:',
        keyPoints: [
          'Siapa yang Berhak? SELURUH pekerja berhak dan wajib menggunakan Stop Work Authority jika melihat tindakan atau kondisi tidak aman.',
          'Kapan Diterapkan? Saat melihat tidak ada JSA, APD kurang, alat rusak, atau potensi bahaya langsung.',
          'Perlindungan Pekerja: Perusahaan menjamin tidak ada tindakan balasan/sanksi bagi pekerja yang menggunakan Stop Work Authority demi keselamatan.'
        ],
        illustrationType: 'rules'
      },
      {
        id: 3,
        title: 'Ringkasan Elemen Aturan Emas Keselamatan',
        titleEn: 'Key Golden Rules Requirements Summary',
        content: 'Area berisiko tinggi yang diatur secara ketat dalam Golden Rules meliputi:',
        keyPoints: [
          '1. Bekerja di Ketinggian (>1.8m): Wajib Full Body Harness dengan double lanyard terhubung ke anchor point sah.',
          '2. Ruang Terbatas (Confined Space): Wajib Izin Kerja (Permit), tes atmosfer gas, dan ada Bintara Pengawas di luar.',
          '3. Surat Izin Kerja Aman (PTW / Permit to Work): Wajib untuk Pekerjaan Panas (Hot Work), Penggalian, dan Kelistrikan.',
          '4. Bebas Alkohol & Obat Terlarang: Dilarang keras berada di tempat kerja di bawah pengaruh alkohol/narkoba.'
        ],
        illustrationType: 'rules'
      }
    ],
    questions: [
      {
        id: 'sgr_q1',
        text: 'Apakah prinsip utama dari pelaksanaan Safety Golden Rules di perusahaan?',
        options: [
          'Aturan opsional yang boleh dilanggar jika mengejar target',
          'Aturan keselamatan mutlak non-kompromi untuk mencegah kecelakaan fatal',
          'Hanya berlaku untuk manajemen puncak',
          'Saran fleksibel saat cuaca hujan saja'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sgr_q2',
        text: 'Siapakah yang memiliki Hak Menghentikan Pekerjaan (Stop Work Authority) jika melihat kondisi tidak aman?',
        options: [
          'Hanya Manajer EHS',
          'Seluruh pekerja, subkontraktor, dan personel di lokasi kerja tanpa kecuali',
          'Hanya Polisi lalu lintas',
          'Tidak ada yang boleh menghentikan pekerjaan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sgr_q3',
        text: 'Berapakah batas ketinggian minimal di mana pekerja WAJIB menggunakan Full Body Harness terikat pada Anchor Point?',
        options: [
          '0.5 Meter',
          '1.8 Meter (atau sesuai regulasi lokal site)',
          '10 Meter',
          '50 Meter'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sgr_q4',
        text: 'Apakah dokumen resmi yang WAJIB diterbitkan sebelum melakukan pekerjaan berisiko tinggi seperti Pekerjaan Panas (Hot Work) atau Ruang Terbatas?',
        options: [
          'Surat Izin Kerja Aman (Permit to Work / PTW)',
          'Nota pembelian barang',
          'Kuitansi pembayaran bensin',
          'Brosur promosi'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'sgr_q5',
        text: 'Bagaimanakah kebijakan perusahaan terhadap pekerja yang masuk lokasi kerja di bawah pengaruh alkohol atau obat-obatan terlarang?',
        options: [
          'Dibiarkan bekerja sambil tidur',
          'Zero Tolerance! Dilarang keras dan dikenakan sanksi disiplin berat serta dikeluarkan dari lokasi',
          'Diberi hadiah minuman tambahan',
          'Diizinkan mengoperasikan alat berat'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sgr_q6',
        text: 'Syarat mutlak apa sajakah yang wajib dipenuhi sebelum pekerja memasuki Ruang Terbatas (Confined Space)?',
        options: [
          'Cukup membawa senter',
          'Izin masuk (Permit), pengujian gas atmosfer (O2, LEL, Toxic), ventilasi memadai, dan adanya pengawas (Standby Person) di luar',
          'Menahan nafas selama di dalam',
          'Membawa makanan ringan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sgr_q7',
        text: 'Berapakah kekuatan minimal yang harus mampu ditahan oleh Titik Angkur (Anchor Point) untuk tali keselamatan full body harness?',
        options: [
          '50 kg (setara kursi kayu)',
          'Minimal 5.000 lbs (sekitar 2.268 kg / 22 kN) per orang yang terhubung',
          '500 gram',
          'Kekuatan apa saja asal ada tempat mengaitkan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'sgr_q8',
        text: 'Tindakan pencegahan kebakaran apa yang WAJIB dilakukan saat melakukan Pekerjaan Panas (Hot Work / Pengelasan / Pemotongan)?',
        options: [
          'Menjauhkan bahan mudah terbakar dalam radius minimal 10-15 meter, menyediakan APAR siap pakai, dan menyiagakan Petugas Pengawas Api (Fire Watch)',
          'Menyiram lantai dengan solar',
          'Menutup semua ventilasi udara',
          'Menyimpan tabung gas elpiji persis di bawah percikan api'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'sgr_q9',
        text: 'Kapan proteksi dinding galian (Shoring / Sloping / Benching) wajib diterapkan pada pekerjaan penggalian?',
        options: [
          'Jika kedalaman galian mencapai 1.5 meter atau lebih, atau tanah berpotensi longsor',
          'Hanya jika galian sudah sedalam 50 meter',
          'Tidak pernah wajib',
          'Hanya saat musim kemarau'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'sgr_q10',
        text: 'Apakah sanksi bagi pekerja yang dengan sengaja melanggar prosedur Safety Golden Rules (seperti sengaja tidak pakai harness di ketinggian)?',
        options: [
          'Diberikan bonus lembur',
          'Tindakan disiplin tegas, pencabutan izin kerja/ID badge, hingga Pemutusan Hubungan Kerja (PHK)',
          'Ditegur lewat senyuman',
          'Diberi libur tambahan'
        ],
        correctOptionIndex: 1,
        points: 10
      }
    ]
  },
  {
    id: 'hand_finger_injury',
    title: 'Hand & Finger Injury Prevention (Pencegahan Cedera Tangan & Jari)',
    titleEn: 'Hand & Finger Injury Prevention',
    subtitle: 'Identifikasi Titik Jepit (Pinch Points), Pemilihan Sarung Tangan & Ergonomi Peralatan',
    subtitleEn: 'Pinch Point Identification, Safety Gloves & Hand Tools Ergonomics',
    badge: 'HFIP',
    estimatedMinutes: 10,
    description: 'Pencegahan cedera tangan dan jari dari bahaya titik jepit (pinch points), bagian berputar, terjepit, terpotong, pemilihan APD sarung tangan yang sesuai, serta penggunaan hand tools secara aman.',
    slides: [
      {
        id: 1,
        title: 'Risiko & Pentingnya Perlindungan Tangan',
        titleEn: 'Hand Hazards & Protection Importance',
        content: 'Tangan adalah anggota tubuh yang paling sering digunakan dan paling rentan mengalami cedera di tempat kerja industri & tambang.',
        keyPoints: [
          'Jenis Cedera Tangan: Terjepit (Pinch Point), Terpotong/Tersayat, Tergores, Luka Bakar, Terkilir/Ergonomi.',
          'Penyebab Utama: Kurang konsentrasi, posisi tangan berada di Line of Fire, tidak memakai sarung tangan yang tepat, memakai perhiasan/cincin.',
          'Ingat Prinsip: "Pikirkan Posisi Tangan Sebelum Melakukan Tindakan!"'
        ],
        illustrationType: 'hands'
      },
      {
        id: 2,
        title: 'Mengenali Titik Jepit (Pinch Points) & Rotating Equipment',
        titleEn: 'Identifying Pinch Points & Rotating Equipment',
        content: 'Pinch Point adalah titik pertemuan antara dua objek bergerak, atau satu objek bergerak dengan objek diam di mana bagian tubuh bisa terjepit:',
        keyPoints: [
          'Contoh Pinch Point: Roda gigi, sabuk conveyor/v-belt, engsel pintu berat, komponen mesin saat pemasangan bolt/nut.',
          'Pasang Pelindung Mesin (Machine Guarding) dan dilarang melepas guard saat mesin beroperasi.',
          'Dilarang memasukkan tangan ke dalam area mesin berputar tanpa mengisolasi LOTO terlebih dahulu.'
        ],
        illustrationType: 'hands'
      },
      {
        id: 3,
        title: 'Pemilihan Sarung Tangan Keselamatan & Hand Tools',
        titleEn: 'Safety Glove Selection & Hand Tools Safety',
        content: 'Sarung tangan harus disesuaikan dengan jenis potensi bahaya pekerjaan:',
        keyPoints: [
          'Impact & Cut Resistant Gloves: Untuk mekanik, bengkel, handling material tajam/berat.',
          'Chemical Gloves (Nitrile/Neoprene): Untuk penanganan bahan kimia beracun/korosif.',
          'Leather / Welding Gloves: Untuk pekerjaan pengelasan dan panas.',
          'Periksa Alat Tangan (Hand Tools): Gunakan kunci pas/ring yang pas, jangan gunakan perkakas modifikasi atau rusak (kunci mekar/retak).'
        ],
        illustrationType: 'hands'
      }
    ],
    questions: [
      {
        id: 'hfi_q1',
        text: 'Apakah yang dimaksud dengan istilah Titik Jepit (Pinch Point)?',
        options: [
          'Titik tempat menyimpan kunci mobil',
          'Pertemuan dua objek atau lebih di mana bagian tubuh (seperti tangan/jari) dapat terjepit atau terperangkap',
          'Ujung dari tali tambang',
          'Pegangan pintu kantor'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'hfi_q2',
        text: 'Manakah jenis sarung tangan yang tepat digunakan untuk menangani material tajam atau pekerjaan mekanik berisiko benturan?',
        options: [
          'Sarung tangan plastik tipis makanan',
          'Sarung tangan Impact & Cut-Resistant (Anti potong & benturan)',
          'Sarung tangan kain biasa yang longgar',
          'Tidak perlu pakai sarung tangan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'hfi_q3',
        text: 'Mengapa penggunaan perhiasan seperti cincin atau jam tangan logam DILARANG saat bekerja mengoperasikan mesin berputar atau kelistrikan?',
        options: [
          'Karena perhiasan bisa hilang',
          'Karena perhiasan berisiko tersangkut (degloving injury) pada komponen berputar atau menghantarkan arus listrik',
          'Agar perhiasan tidak kotor',
          'Karena dilarang agama'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'hfi_q4',
        text: 'Apakah tindakan keselamatan wajib sebelum tangan dimasukkan ke area mesin untuk membersihkan atau memperbaiki bagian dalam?',
        options: [
          'Langsung masukkan tangan saat mesin menyala',
          'Lakukan Prosedur LOTO (Lock Out Tag Out) & pastikan mesin mati total (Nol Energi)',
          'Memutar mesin dengan kecepatan penuh',
          'Menutup mata saat bekerja'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'hfi_q5',
        text: 'Bagaimanakah kondisi alat tangan (Hand Tools) yang aman digunakan?',
        options: [
          'Kunci pas yang sudah mekar dan retak',
          'Palu dengan gagang kayu yang sudah patah disambung isolasi',
          'Perkakas standar pabrikan dalam kondisi baik, tidak retak, dan ukurannya sesuai dengan baut',
          'Perkakas rakitan sendiri yang tidak teruji'
        ],
        correctOptionIndex: 2,
        points: 10
      },
      {
        id: 'hfi_q6',
        text: 'Mengapa dilarang menggunakan sarung tangan kain longgar saat bekerja di dekat mesin bor duduk atau mesin bubut berputar?',
        options: [
          'Karena serat kain sarung tangan dapat tersangkut pada sumbu putar dan menarik seluruh tangan masuk ke mesin',
          'Agar tangan terasa dingin',
          'Karena sarung tangan kain terlalu licin',
          'Hanya karena alasan estetika'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'hfi_q7',
        text: 'Saat memindahkan atau menurunkan beban berat, bagaimanakah posisi tangan yang aman?',
        options: [
          'Meletakkan jari tepat di bagian bawah alas beban yang akan menyentuh lantai',
          'Memposisikan tangan pada pegangan yang aman / sisi samping beban dan pastikan bantalan balok sudah terpasang agar jari tidak terjepit',
          'Membiarkan beban jatuh ke kaki',
          'Menahan beban dengan ujung jari'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'hfi_q8',
        text: 'Apakah alat bantu yang wajib digunakan saat memotong benda kecil pada mesin gergaji meja agar tangan terhindar dari mata pisau?',
        options: [
          'Batang pendorong kayu (Push Stick)',
          'Jari telunjuk langsung',
          'Pulpen plastik',
          'Kain basah'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'hfi_q9',
        text: 'Jenis sarung tangan apakah yang wajib digunakan saat menangani bahan kimia berbahaya dan asam korosif?',
        options: [
          'Sarung tangan katun rajut',
          'Sarung tangan kulit las',
          'Sarung tangan Nitrile / Neoprene / Butyl tahan kimia',
          'Sarung tangan wool'
        ],
        correctOptionIndex: 2,
        points: 10
      },
      {
        id: 'hfi_q10',
        text: 'Bagaimanakah prinsip keselamatan penggunaan pisau pemotong (Cutter / Utility Knife)?',
        options: [
          'Memotong dengan arah mengarah ke badan sendiri',
          'Memotong dengan arah menjauhi tubuh dan selalu gunakan cutter dengan mekanisme pengunci / pisau berpegas (safety cutter)',
          'Menggunakan mata pisau yang sudah tumpul dan berkarat',
          'Menyimpan cutter terbuka di saku celana'
        ],
        correctOptionIndex: 1,
        points: 10
      }
    ]
  },
  {
    id: 'power_tools',
    title: 'Power Tools Safety (Keselamatan Alat Daya & Perkakas Listrik)',
    titleEn: 'Power Tools Safety',
    subtitle: 'Penggunaan Aman Gerinda, Bor, Saw, Inspeksi Kabel, Guarding & APD Khusus',
    subtitleEn: 'Safe Usage of Grinders, Drills, Saws, Cable Inspection, Guarding & PPE',
    badge: 'PT',
    estimatedMinutes: 10,
    description: 'Pengoperasian perkakas bertenaga (Listrik, Pneumatik, Hidrolik) secara aman, mencakup gerinda, bor, potong, inspeksi pra-pakai, keselamatan kelistrikan/GFCI, serta alat pelindung diri.',
    slides: [
      {
        id: 1,
        title: 'Prinsip Keselamatan & Inspeksi Pra-Pakai Power Tools',
        titleEn: 'Power Tools Safety Principles & Pre-Use Inspection',
        content: 'Power Tools (alat bertenaga listrik, angin/pneumatik, hidrolik) memiliki kecepatan dan energi tinggi yang berpotensi memicu bahaya terpotong, tersengat listrik, atau terlempar serpihan.',
        keyPoints: [
          'Inspeksi Fisik Pra-Pakai (Pre-Use Check): Periksa kondisi fisik alat, kabel listrik, colokan, steker, tombol switch, serta baut pengikat.',
          'Dilarang Menggunakan Alat Rusak: Jika kabel terkelupas, steker retak, atau tombol kendor, beri label "OUT OF SERVICE" dan laporkan ke atasan.',
          'Pastikan Grounding & GFCI (ELCB): Penggunaan power tools outdoor/area basah wajib terhubung dengan pemutus arus bocor (ELCB/GFCI) dan ber-grounding baik.'
        ],
        illustrationType: 'hands'
      },
      {
        id: 2,
        title: 'Safety Guarding & Pengoperasian Gerinda / Potong',
        titleEn: 'Safety Guarding & Safe Operation of Grinders/Saws',
        content: 'Gerinda dan mesin potong adalah power tools berisiko tinggi yang paling sering menimbulkan kecelakaan jika abaikan prosedur:',
        keyPoints: [
          'Wajib Pelindung Mesin (Wheel Guard): DILARANG keras melepas guard/pelindung piringan gerinda saat beroperasi.',
          'Cek Spesifikasi RPM Piringan Batu: Pastikan Max RPM batu gerinda/cutting disc LEBIH BESAR daripada RPM mesin gerinda.',
          'Pemeriksaan Batu Gerinda (Ring Test): Periksa retakan atau sumbing pada batu gerinda sebelum dipasang. Jangan pakai batu yang retak!',
          'Arah Percikan Api & Line of Fire: Arahkan percikan ke area bebas dari bahan mudah terbakar (bensin/thinner) dan pastikan ada APAR di dekatnya.'
        ],
        illustrationType: 'hands'
      },
      {
        id: 3,
        title: 'APD Khusus & Prosedur Aman Penggunaan Power Tools',
        titleEn: 'Specialized PPE & Safe Operating Procedures for Power Tools',
        content: 'Penggunaan alat pelindung diri secara lengkap dan perilaku kerja aman menjamin perlindungan maksimal bagi operator:',
        keyPoints: [
          'APD Wajib Power Tools: Safety Glasses + Face Shield (Kacamata & Pelindung Muka), Earplug/Earmuff (Pelindung Pendengaran), Masker Debu/Respirator, dan Sarung Tangan Kulit/Safety.',
          'Pakaian Kerja Rapi: Dilarang memakai baju longgar, dasi, atau perhiasan yang bisa tersangkut pada sumbur/mesin berputar.',
          'Cabut Colokan Listrik saat Ganti Mata Bor / Batu Gerinda: Matikan switch dan cabut sumber listrik sebelum mengganti asesoris!',
          'Posisi Bekerja Stabil: Pastikan pijakan kaki kokoh dan benda kerja dijepit rapat dengan ragum (vise/clamp), jangan dipegang tangan kosong.'
        ],
        illustrationType: 'hands'
      }
    ],
    questions: [
      {
        id: 'pt_q1',
        text: 'Apakah tindakan pertama yang wajib dilakukan sebelum menggunakan perkakas listrik (Power Tools)?',
        options: [
          'Langsung menyalakan alat tanpa diperiksa',
          'Melakukan Inspeksi Pra-Pakai (kondisi kabel, tombol switch, steker, dan pelindung)',
          'Memotong kabel yang terlalu panjang',
          'Menyiram alat dengan air agar tidak panas'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q2',
        text: 'Mengapa spesifikasi Max RPM pada batu gerinda harus LEBIH BESAR dari RPM mesin gerinda?',
        options: [
          'Agar harga batu gerinda lebih murah',
          'Mencegah batu gerinda pecah/hancur akibat putaran mesin yang melebihi batas kekuatan batu',
          'Agar warna batu gerinda lebih mengkilap',
          'Tidak berpengaruh apa-apa'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q3',
        text: 'Manakah kombinasi APD wajib saat mengoperasikan mesin gerinda potong/sanding?',
        options: [
          'Kacamata hitam biasa saja',
          'Safety Glasses + Face Shield (Pelindung Muka) + Earplug + Sarung Tangan Safety',
          'Sandal jepit dan topi pantai',
          'Hanya masker kain'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q4',
        text: 'Apakah yang wajib dilakukan sebelum mengganti batu gerinda atau mata bor pada power tools?',
        options: [
          'Mengganti saat alat masih berputar tajam',
          'Mematikan switch dan mencabut steker dari colokan listrik / sumber energi',
          'Menyiram dengan minyak pelumas saat alat menyala',
          'Menyuruh teman memegang tombol switch ON'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q5',
        text: 'Mengapa pelindung keselamatan (Safety Wheel Guard) pada mesin gerinda DILARANG dilepas saat bekerja?',
        options: [
          'Agar mesin terlihat lebih bagus',
          'Melindungi operator dari serpihan pecahnya batu gerinda dan arah percikan api berbahaya',
          'Agar mesin gerinda terasa lebih berat',
          'Karena guard hanya pajangan'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q6',
        text: 'Apakah fungsi perangkat GFCI (Ground Fault Circuit Interrupter) atau ELCB pada instalasi power tools?',
        options: [
          'Mempercepat putaran mesin bor',
          'Memutuskan aliran listrik seketika saat terjadi kebocoran arus untuk mencegah operator tersengat listrik (electrical shock)',
          'Menghidupkan lampu penerangan',
          'Menurunkan tagihan listrik kantor'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q7',
        text: 'Bahaya apa yang timbul jika menggunakan kabel rol / ekstensi yang terkelupas atau dibiarkan terendam genangan air?',
        options: [
          'Risiko korsleting listrik, kebakaran, dan sengatan listrik bertegangan tinggi yang fatal bagi pekerja',
          'Air menjadi lebih bersih',
          'Mesin menjadi lebih dingin',
          'Tidak ada bahaya sama sekali'
        ],
        correctOptionIndex: 0,
        points: 10
      },
      {
        id: 'pt_q8',
        text: 'Bagaimanakah cara pengujian cincin (Ring Test) untuk mengecek keretakan internal pada batu gerinda baru?',
        options: [
          'Membanting batu gerinda ke lantai',
          'Mengetuk batu gerinda secara lembut dengan benda non-logam (seperti gagang obeng kayu) dan mendengarkan suara dentingannya (suara jernih menandakan tidak ada retak)',
          'Merendam batu gerinda dalam minyak seharian',
          'Membakar batu gerinda'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q9',
        text: 'Bagaimanakah cara memegang dan mengendalikan benda kerja saat menggunakan mesin bor tangan atau gerinda?',
        options: [
          'Memegang benda kerja dengan tangan telanjang sambil mengobrol',
          'Menjepit benda kerja secara kokoh menggunakan ragum (vise) atau clamp, jangan pernah ditahan dengan tangan kosong',
          'Menahan benda kerja dengan kaki',
          'Membiarkan benda kerja bebas bergerak'
        ],
        correctOptionIndex: 1,
        points: 10
      },
      {
        id: 'pt_q10',
        text: 'Mengapa dilarang mengunci tombol saklar (Locking Switch / Trigger Lock) saat mengoperasikan power tools genggam?',
        options: [
          'Agar mesin lebih hemat daya baterai',
          'Karena jika terjadi tendangan balik (kickback) atau kecelakaan, mesin tidak dapat mati seketika saat terlepas dari genggaman',
          'Karena tombol kunci bisa patah',
          'Hanya anjuran tanpa alasan keselamatan'
        ],
        correctOptionIndex: 1,
        points: 10
      }
    ]
  }
];
